<template>
  <div class="vv-speech-bubble">
    <!-- this div exist so we can hide the overflow without hiding the ::after -->
    <!-- which is the little spike under the bubble -->
    <div class="hidden-overflow">
      <div class="banner" v-if="title || subtitle">
        {{ title | uppercase }}
        <span class="subtitle" v-if="subtitle">{{ subtitle }}</span>
      </div>
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VvSpeechBubble',
  props: {
    title: String,
    icon: String,
    subtitle: String
  },
  filters: {
    uppercase(value) {
      return value.toUpperCase()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.vv-speech-bubble {
  position: relative;
  box-shadow: 0 14px 28px 5px rgba(220, 220, 220, 0.5);

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 80%;
    width: 0;
    height: 0;
    border: 26px solid transparent;
    border-top-color: white;
    border-bottom: 0;
    border-right: 0;
    margin-right: -13px;
    margin-bottom: -25px;
  }

  & .hidden-overflow {
    overflow: hidden;
    border-radius: 0.4em;

    & .banner {
      padding: 6px 30px;
      font-size: 10.8px;
      font-weight: 900;
      text-align: left;
      background-image: linear-gradient(258deg, $tertiary, $primary);
      color: #ffffff;

      .subtitle {
        float: right;
      }
    }

    & .content {
      padding: 20px 25px;
      text-align: left;
      font-weight: bold;
      background: #ffffff;
    }
  }
}
</style>
